export default function MinusIcon(props) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 18">
            <path stroke="#EF8B22" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M5.2 9h14.6"/>
        </svg>
    )
}